import React, { useState } from 'react';
// @ts-ignore
import styles from './MedicalReportsList.module.scss';
import apiClient from '../../Services/ApiClient';
import { useEffectAsync } from '../../helpers';
import AddButton from '../Button/AddButton';
import MedicalReportDetailModal from './MedicalReportDetailModal';
import { DOCUMENTS } from '../../Modules/Documents/documents.graphql';
import { useAppContext } from '../../Services/AppContext';
import MedicalReportsListItem from './MedicalReportsListItem';
import ScrollContainer from '../../Modules/Base/Components/ScrollContainer';
import Text from '../Base/Text/Text';

interface MedicalReportsListProps {
	patientId: string;
	workplaceId: string;
	loggedUserId: string;
	caseId?: string;
}

export default function MedicalReportsList(props: MedicalReportsListProps) {
	const { patientId, workplaceId, loggedUserId, caseId } = props;
	const { translation } = useAppContext();
	const [data, setData] = useState([]);
	const [detailOpen, setDetailOpen] = useState(false);

	// @ts-ignore
	useEffectAsync(async () => {
		await loadData();
	}, []);

	// @ts-ignore
	const loadData = async () => {
		const variables = {
			userId: patientId,
			workplaceId: workplaceId,
			types: ['MEDICAL_REPORT'],
		};
		const { meta, data } = await apiClient.graphql({
			query: DOCUMENTS,
			variables,
			fetchPolicy: 'network-only',
		});
		const dataToSort = [...data.documents.data];
		const sortedData = dataToSort.sort(
			(a, b) =>
				new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
		);
		console.log('sortedData', sortedData);
		setData(sortedData);
	};

	const handleCreateNew = () => {
		setDetailOpen(true);
	};

	// @ts-ignore
	const handleOnCreate = async () => {
		await loadData();
		setDetailOpen(false);
	};

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.options}>
					<AddButton
						title={translation['base.shared.createMedicalReport']}
						onClick={handleCreateNew}
					/>
				</div>
				<div className={styles.header}>
					<Text
						className={styles.date}
						tx='component.medicalReportList.header.date'
					/>
					<Text
						className={styles.document}
						tx='component.medicalReportList.header.document'
					/>
				</div>
				<ScrollContainer>
					<div className={styles.list}>
						{data.map(item => (
							<MedicalReportsListItem item={item} key={item.id} />
						))}
					</div>
				</ScrollContainer>
			</div>
			<MedicalReportDetailModal
				opened={detailOpen}
				onClose={handleOnCreate}
				workplaceId={workplaceId}
				patientId={patientId}
				loggedUserId={loggedUserId}
				caseId={caseId}
			/>
		</>
	);
}
